import { ipCountryQuery, configQuery } from '@gig/magic-common';
import { GAMES_SHOW_FAVOURITES_QUERY, GAMES_IS_PLAY_FOR_FUN_QUERY, GAMES_LOBBY_COMMAND_CHANGE, USER_LOGGED_IN_UPDATED, GAMES_SHOW_FAVOURITES_UPDATED, GAMES_IS_PLAY_FOR_FUN_UPDATED } from '@gig/magic-messages';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class GamesListService {
  constructor() {
    this.lobby = null;
    this.lobbyPath = null;
    this.loggedIn = false;
    this.registerSchemas();
    this.registerQueries();
    this.subscribeToLobbyChanges();
    this.subscribeToLoggedInChanges();
  }
  registerQueries() {
    window.queryBus.subscribe(GAMES_SHOW_FAVOURITES_QUERY, () => __async(this, null, function* () {
      return yield this.areFavouritesEnabled();
    }));
    window.queryBus.subscribe(GAMES_IS_PLAY_FOR_FUN_QUERY, () => __async(this, null, function* () {
      return yield this.isPlayForFunEnabled();
    }));
  }
  subscribeToLobbyChanges() {
    window.commandBus.subscribe(GAMES_LOBBY_COMMAND_CHANGE, (event) => __async(this, null, function* () {
      var _a, _b, _c, _d;
      this.lobby = (_b = (_a = event.payload) == null ? void 0 : _a.lobby) != null ? _b : null;
      this.lobbyPath = (_d = (_c = event.payload) == null ? void 0 : _c.lobbyPath) != null ? _d : null;
      yield this.publishFavouritesIconUpdated();
    }));
  }
  subscribeToLoggedInChanges() {
    window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, (event) => __async(this, null, function* () {
      var _a;
      this.loggedIn = (_a = event.payload) != null ? _a : false;
      yield Promise.all([
        this.publishFavouritesIconUpdated(),
        this.publishIsPlayForFunUpdated()
      ]);
    }), { replay: true });
  }
  publishFavouritesIconUpdated() {
    return __async(this, null, function* () {
      const showFavourites = yield this.areFavouritesEnabled();
      window.eventBus.publish(GAMES_SHOW_FAVOURITES_UPDATED, showFavourites);
    });
  }
  publishIsPlayForFunUpdated() {
    return __async(this, null, function* () {
      const isPlayForFun = yield this.isPlayForFunEnabled();
      window.eventBus.publish(GAMES_IS_PLAY_FOR_FUN_UPDATED, isPlayForFun);
    });
  }
  areFavouritesEnabled() {
    return __async(this, null, function* () {
      if (!this.loggedIn) {
        return false;
      }
      const [enabled, showForLobby] = yield Promise.all([
        this.favouritesEnabled(),
        this.shouldShowFavouritesForLobby()
      ]);
      return enabled && showForLobby;
    });
  }
  isPlayForFunEnabled() {
    return __async(this, null, function* () {
      if (this.loggedIn) {
        return false;
      }
      const [countries, ipCountry] = yield Promise.all([
        this.getPlayForFunBlockedCountries(),
        ipCountryQuery()
      ]);
      return !countries.includes(ipCountry);
    });
  }
  shouldShowFavouritesForLobby() {
    return __async(this, null, function* () {
      if (!this.lobbyPath) {
        return false;
      }
      const allowedLobbies = yield this.getLobbiesWithRecentGames();
      return allowedLobbies.includes(this.lobbyPath);
    });
  }
  favouritesEnabled() {
    return __async(this, null, function* () {
      return !!(yield configQuery("gamePlay.favouritesEnabled"));
    });
  }
  getLobbiesWithRecentGames() {
    return __async(this, null, function* () {
      var _a;
      return (_a = yield configQuery("lobbiesRoutesToShowLastPlayedGames")) != null ? _a : [];
    });
  }
  getPlayForFunBlockedCountries() {
    return __async(this, null, function* () {
      var _a;
      return (_a = yield configQuery("gamePlay.playForFunBlockedCountries")) != null ? _a : [];
    });
  }
  registerSchemas() {
    window.eventBus.register(GAMES_SHOW_FAVOURITES_UPDATED, {
      type: "boolean"
    });
    window.queryBus.register(GAMES_IS_PLAY_FOR_FUN_UPDATED, {
      type: "boolean"
    });
    window.commandBus.register(GAMES_LOBBY_COMMAND_CHANGE, {
      type: "object",
      properties: {
        lobby: {
          anyOf: [
            {
              type: "string"
            },
            {
              type: "null"
            }
          ]
        },
        lobbyPath: {
          anyOf: [
            {
              type: "string"
            },
            {
              type: "null"
            }
          ]
        }
      }
    });
  }
}

export { GamesListService };
